<template>
    <v-container class="howItWorks">
        
        <div class="d-none d-sm-flex">
            <v-row  style="max-width:700px;margin-left:auto;margin-right:auto">
                <v-col cols="4" class="text-center">
                    <v-avatar  size="30" class="my-4">
                        <v-img  src="/how_it_works/accessible.svg"></v-img>
                    </v-avatar>
                    <div class="text-center hiwTitle synThickFont mb-3">Accessible</div>
                </v-col>
                <v-col cols="4" class="text-center">
                    <v-avatar  size="30" class="my-4">
                        <v-img  src="/how_it_works/fast.svg"></v-img>
                    </v-avatar>
                    <div class="text-center hiwTitle synThickFont mb-3">Fast</div>
                </v-col>
                <v-col cols="4" class="text-center">
                    <v-avatar  size="30" class="my-4">
                        <v-img  src="/how_it_works/simple.svg"></v-img>
                    </v-avatar>
                    <div class="text-center hiwTitle synThickFont mb-3">Simple</div>
                </v-col>
            </v-row>
        </div>

        <div class="d-flex d-sm-none">
            <v-row  style="max-width:700px;margin-left:auto;margin-right:auto">
                <v-col cols="4" class="text-center">
                    <v-avatar  size="20" class="my-4">
                        <v-img  src="/how_it_works/accessible.svg"></v-img>
                    </v-avatar>
                    <div class="text-center hiwTitle synThickFont mb-3" style="font-size:18px">Accessible</div>
                </v-col>
                <v-col cols="4" class="text-center">
                    <v-avatar  size="20" class="my-4">
                        <v-img  src="/how_it_works/fast.svg"></v-img>
                    </v-avatar>
                    <div class="text-center hiwTitle synThickFont mb-3" style="font-size:18px">Fast</div>
                </v-col>
                <v-col cols="4" class="text-center">
                    <v-avatar  size="20" class="my-4">
                        <v-img  src="/how_it_works/simple.svg"></v-img>
                    </v-avatar>
                    <div class="text-center hiwTitle synThickFont mb-3" style="font-size:18px">Simple</div>
                </v-col>
            </v-row>
        </div>
        
        <div class="d-none d-sm-flex">
            <div class="text-center hiwCaption">We developed this platform with one key thought in mind: <span class="synThickFont">Straight-forward, simple and high quality</span>.</div> 
        </div>

        <div class="d-flex d-sm-none">
            <div class="text-center hiwCaption px-1" style="font-size:13px">We developed this platform with one key thought in mind: <span class="synThickFont">Straight-forward, simple and high quality</span>.</div> 
        </div>

        <div v-if="!signedIn" class="text-center mt-2 ">
            <v-btn color="syn_blue_button" style="border-radius:17px" class="white--text mt-4 linkHover" :to="{ name: 'Signup'}">Sign Up</v-btn>
        </div>
        
        <div class="d-none d-md-flex">
            <div class="text-center mt-5 mb-2 " style="margin-top:30px !important;margin-left:auto;margin-right:auto">
                <iframe width="728" height="407" style="border-radius:5px" src="https://www.youtube.com/embed/IBYTToz3ClU" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
            </div>
        </div>

        <div class="d-none d-sm-flex d-md-none">
            <div class="text-center mt-5 mb-2 " style="margin-top:30px !important;margin-left:auto;margin-right:auto">
                <iframe width="550" height="307" style="border-radius:5px" src="https://www.youtube.com/embed/IBYTToz3ClU" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
            </div>
        </div>

        <div class="d-flex d-sm-none">
            <div class="text-center mt-5 mb-2 " style="margin-top:30px !important;margin-left:auto;margin-right:auto">
                <iframe width="310" height="170" style="border-radius:5px" src="https://www.youtube.com/embed/IBYTToz3ClU" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
            </div>
        </div>

        <div class="d-none d-sm-flex d-md-none">
            <div class="grey--text mt-5 text-center" style="margin-left:auto;margin-right:auto"><i>Get your first feedback report in 4 steps.</i></div>
        </div>
        <div class="d-flex d-sm-none">
            <div class="grey--text mt-2 text-center" style="font-size:12px;margin-left:auto;margin-right:auto"><i>Get your first feedback report in 4 steps.</i></div>
        </div>
        
       

        <Overlay :overlay="overlay" />
    </v-container>
</template>
<script>
import firebase from 'firebase/app'
import 'firebase/auth'
import Overlay from '@/components/layout/Overlay'

export default {
    name:"HowItWorks",
    data() {
        return {
            video: false,
            signedIn: false,
            overlay:true
        }
    },
    components: {
        Overlay
    },
    created() {
        firebase.auth().onAuthStateChanged((user) => {
            if (user) {
                this.signedIn=true
                this.overlay= false
            } else {
                this.overlay= false
            }
        })
    },
    methods: {
        showVideo() {
            this.video=true
        }
    }
}
</script>
<style>
.howItWorks{
      -webkit-animation: fadein 1s; /* Safari, Chrome and Opera > 12.1 */
       -moz-animation: fadein 1s; /* Firefox < 16 */
        -ms-animation: fadein 1s; /* Internet Explorer */
         -o-animation: fadein 1s; /* Opera < 12.1 */
            animation: fadein 1s;
} 
.hiwTitle{
    font-size:2em;
    color: white;
    /* letter-spacing: 3px; */
}
.hiwCaption{
    color: white;
    max-width: 800px;
    margin-left: auto;
    margin-right: auto;
}
.rounded-card{
    border-radius:10px !important;
}
</style>